module.exports = __webpack_public_path__ + "img/robot_half.047d9974.svg";